"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseRunningPlayTypeConfigs = exports.ballInPlayResultConfigs = exports.PitchSpeedProvider = exports.PitchResult = exports.ReplaceRunnerFlavor = exports.BaseballOffensiveLocation = exports.BaseballOffensiveRole = void 0;
var BaseballOffensiveRole;
(function (BaseballOffensiveRole) {
    BaseballOffensiveRole["Batter"] = "batter";
    BaseballOffensiveRole["Runner"] = "runner";
})(BaseballOffensiveRole = exports.BaseballOffensiveRole || (exports.BaseballOffensiveRole = {}));
var BaseballOffensiveLocation;
(function (BaseballOffensiveLocation) {
    BaseballOffensiveLocation["Batter"] = "batter";
    BaseballOffensiveLocation["RunnerOnFirst"] = "runner_first";
    BaseballOffensiveLocation["RunnerOnSecond"] = "runner_second";
    BaseballOffensiveLocation["RunnerOnThird"] = "runner_third";
})(BaseballOffensiveLocation = exports.BaseballOffensiveLocation || (exports.BaseballOffensiveLocation = {}));
var ReplaceRunnerFlavor;
(function (ReplaceRunnerFlavor) {
    ReplaceRunnerFlavor["SpecialPinchRunner"] = "special_pinch_runner";
    ReplaceRunnerFlavor["RetroactiveSubstitution"] = "retroactive_sub";
})(ReplaceRunnerFlavor = exports.ReplaceRunnerFlavor || (exports.ReplaceRunnerFlavor = {}));
// illegal_pitch is a softball specific event
var PitchResult;
(function (PitchResult) {
    PitchResult["Ball"] = "ball";
    PitchResult["IntentionalBall"] = "intentional_ball";
    PitchResult["StrikeSwinging"] = "strike_swinging";
    PitchResult["StrikeLooking"] = "strike_looking";
    PitchResult["Foul"] = "foul";
    PitchResult["BallInPlay"] = "ball_in_play";
    PitchResult["IllegalPitch"] = "illegal_pitch";
    PitchResult["FoulTip"] = "foul_tip";
    PitchResult["FoulBunt"] = "foul_bunt";
})(PitchResult = exports.PitchResult || (exports.PitchResult = {}));
var PitchSpeedProvider;
(function (PitchSpeedProvider) {
    PitchSpeedProvider["POCKET_RADAR"] = "pocket_radar";
    PitchSpeedProvider["USER"] = "user";
})(PitchSpeedProvider = exports.PitchSpeedProvider || (exports.PitchSpeedProvider = {}));
exports.ballInPlayResultConfigs = {
    single: { bases: 1, batterOut: false, error: false },
    double: { bases: 2, batterOut: false, error: false },
    triple: { bases: 3, batterOut: false, error: false },
    home_run: { bases: 4, batterOut: false, error: false },
    dropped_third_strike: { bases: 1, batterOut: false, error: false },
    dropped_third_strike_batter_out: { bases: 1, batterOut: true, error: false },
    fielders_choice: { bases: 1, batterOut: false, error: false },
    error: { bases: 1, batterOut: false, error: true },
    sacrifice_bunt: { bases: 1, batterOut: false, error: false },
    sacrifice_fly: { bases: 1, batterOut: true, error: false },
    sacrifice_bunt_error: { bases: 1, batterOut: false, error: true },
    sacrifice_fly_error: { bases: 1, batterOut: false, error: true },
    batter_out: { bases: 0, batterOut: true, error: false },
    batter_out_advance_runners: { bases: 1, batterOut: true, error: false },
    offensive_interference: { bases: 0, batterOut: true, error: false },
    infield_fly: { bases: 0, batterOut: true, error: false },
    other_out: { bases: 0, batterOut: true, error: false },
    foul_tip_out: { bases: 0, batterOut: true, error: false },
};
exports.baseRunningPlayTypeConfigs = {
    offensive_interference: { runnerOut: true, error: false },
    stole_base: { runnerOut: false, error: false },
    defensive_indifference: { runnerOut: false, error: false },
    passed_ball: { runnerOut: false, error: false },
    on_same_pitch: { runnerOut: false, error: false },
    wild_pitch: { runnerOut: false, error: false },
    attempted_pickoff: { runnerOut: false, error: false },
    fielders_choice_attempted_pickoff: { runnerOut: false, error: false },
    advanced_on_error: { runnerOut: false, error: true },
    on_same_error: { runnerOut: false, error: false },
    out_on_appeal: { runnerOut: true, error: false },
    caught_stealing: { runnerOut: true, error: false },
    other_out: { runnerOut: true, error: false },
    other_advance: { runnerOut: false, error: false },
    picked_off: { runnerOut: true, error: false },
    did_not_score: { runnerOut: false, error: false },
    advanced_on_last_play: { runnerOut: false, error: false },
    remained_on_last_play: { runnerOut: false, error: false },
    out_on_last_play: { runnerOut: true, error: false },
};
//# sourceMappingURL=definitions.js.map